export default __webpack_public_path__ + "static/media/ls1_g02.e555d0dd.png";